import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { usersReducer } from './reducers/usersReducer'
import { candidatesReducer } from './reducers/candidatesReducer'
import { schoolsReducer } from './reducers/schoolsReducer'
import { profileTypesReducer } from './reducers/profileTypesReducer'
import { selectionsReducer } from './reducers/selectionsReducer'
import { calendarsReducer } from './reducers/calendarsReducer'
import { notificationsReducer } from './reducers/notificationsReducer'
import { subscriptionReducer } from './reducers/subscriptionReducer'
import { subscriptionProductProductReducer } from './reducers/subscriptionProductReducer'
import { ticketsReducer } from './reducers/ticketsReducer'
import { miscellaneousReducer } from './reducers/miscellaneousReducer'
import { choosesReducer } from './reducers/choosesReducer'
import { stocksReducer } from './reducers/stocksReducer'
import { schoolStaffsReducer } from './reducers/schoolStaffReducer'
import { labelsReducer } from './reducers/labelsReducer'

const intialState = {}
const appReducer = combineReducers({
    users: usersReducer,
    candidates: candidatesReducer,
    schools: schoolsReducer,
    profileTypes: profileTypesReducer,
    selections: selectionsReducer,
    calendars: calendarsReducer,
    notifications: notificationsReducer,
    subscriptions: subscriptionReducer,
    subscriptionProducts: subscriptionProductProductReducer,
    tickets: ticketsReducer,
    miscellaneous: miscellaneousReducer,
    chooses: choosesReducer,
    stocks: stocksReducer,
    schoolStaffs: schoolStaffsReducer,
    labels: labelsReducer,
})

const reducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
}

const composeEnhancer = window._REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(reducer, intialState, composeEnhancer(applyMiddleware(thunk)))

export default store